import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incometax-parameter',
  templateUrl: './incometax-parameter.component.html',
  styleUrls: ['./incometax-parameter.component.css']
})
export class IncometaxParameterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/incometax-parameter/incometax-parameter.component.ts